/* Geeknson attribution v1 — first-party first/last touch capture + Shopify cart attributes.
 * Isolated, defensive (never throws, no layout impact, no UI). Writes leading-underscore cart
 * attributes (_attr_*) which are HIDDEN in cart/checkout UI but copied to order.note_attributes,
 * where the LOGEEK webhook reads them. Direct / no-UTM visits are a no-op (no error, no empty cart).
 */
(function () {
  "use strict";
  try {
    var LS = window.localStorage;
    var K_FIRST = "gk_attr_first", K_LAST = "gk_attr_last", K_WRITTEN = "gk_attr_written";

    // UTM taxonomy v1: allowed source -> default medium. Unknown source is still captured (flagged).
    var DEFAULT_MEDIUM = {
      instagram: "social", facebook: "social", reddit: "social",
      discord: "community", email: "email",
      google: "paid", meta: "paid",
      blog: "internal", logeek: "internal",
      marcin: "manual", helena: "manual", gosia: "manual", filip: "manual",
      ania_logistics: "manual", paulina_support: "manual", terry: "manual"
    };

    function qp(name) {
      try {
        var v = new URLSearchParams(window.location.search).get(name);
        return v ? String(v).trim().toLowerCase() : null;
      } catch (e) { return null; }
    }
    function gaClientId() {
      try {
        var m = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.([\d.]+)/);
        return m ? m[1] : null; // "clientId.timestamp" portion
      } catch (e) { return null; }
    }
    function nowIso() { try { return new Date().toISOString(); } catch (e) { return null; } }

    var source = qp("utm_source");
    if (source) {
      var medium = qp("utm_medium") || DEFAULT_MEDIUM[source] || "unknown";
      var touch = {
        source: source,
        medium: medium,
        campaign: qp("utm_campaign"),
        content: qp("utm_content"),
        term: qp("utm_term"),
        landing_page: (window.location.pathname + window.location.search).slice(0, 500),
        referrer: (document.referrer || "").slice(0, 300) || null,
        ga_client_id: gaClientId(),
        unknown_source: DEFAULT_MEDIUM[source] ? false : true,
        captured_at: nowIso()
      };
      // first_touch: set once. last_touch: overwrite on every UTM-bearing visit.
      if (!LS.getItem(K_FIRST)) LS.setItem(K_FIRST, JSON.stringify(touch));
      LS.setItem(K_LAST, JSON.stringify(touch));
    }

    // Build cart attributes from stored touches (only if we ever captured a UTM).
    var firstRaw = LS.getItem(K_FIRST), lastRaw = LS.getItem(K_LAST);
    if (!lastRaw) return; // direct / no-UTM ever -> nothing to attribute, no-op
    var last;
    try { last = JSON.parse(lastRaw); } catch (e) { return; }

    var attrs = {
      _attr_utm_source: last.source || "",
      _attr_utm_medium: last.medium || "",
      _attr_utm_campaign: last.campaign || "",
      _attr_utm_content: last.content || "",
      _attr_utm_term: last.term || "",
      _attr_landing_page: last.landing_page || "",
      _attr_referrer: last.referrer || "",
      _attr_ga_client_id: (gaClientId() || last.ga_client_id || ""),
      _attr_first: firstRaw || "",
      _attr_last: lastRaw || ""
    };

    // Write once per unchanged snapshot (no cart clutter, no races with add-to-cart).
    var snapshot = JSON.stringify(attrs);
    if (LS.getItem(K_WRITTEN) === snapshot) return;

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (r && r.ok) LS.setItem(K_WRITTEN, snapshot);
    }).catch(function () { /* best-effort; never surface to the customer */ });
  } catch (e) { /* swallow — attribution must never break the storefront */ }
})();
